import { FC } from 'react'
import { Button } from '../../../components/Button'
import { useTranslations } from '../../shared/hooks/useTranslations'
import {
  BigAnimationContainer,
  ButtonsContainer,
  ConfirmationModalContainer,
  SmallAnimationContainer,
} from './styled'
import { RenderIf } from 'components/RenderIf'
import Lottie from 'lottie-react'

type ConfirmationModalProps = {
  text?: string
  onConfirm?: () => void
  okText?: string
  onCancel?: () => void
  cancelText?: string
  animationJSON?: any
  isBigAnimationIncluded?: boolean
  isLoading?: boolean
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  text = '',
  onConfirm,
  onCancel,
  okText,
  cancelText,
  animationJSON,
  isBigAnimationIncluded = false,
  isLoading = false,
}) => {
  const t = useTranslations()

  return (
    <ConfirmationModalContainer>
      <RenderIf condition={isBigAnimationIncluded}>
        <h2>{text}</h2>
      </RenderIf>
      <RenderIf condition={Boolean(animationJSON && !isBigAnimationIncluded)}>
        <SmallAnimationContainer>
          <Lottie animationData={animationJSON} loop={true} />
        </SmallAnimationContainer>
      </RenderIf>
      <RenderIf condition={Boolean(animationJSON && isBigAnimationIncluded)}>
        <BigAnimationContainer>
          <div style={{ width: '100%', alignSelf: 'center' }}>
            <Lottie animationData={animationJSON} loop={true} />
          </div>
        </BigAnimationContainer>
      </RenderIf>
      <RenderIf condition={!isBigAnimationIncluded}>
        <h2>{text}</h2>
      </RenderIf>
      <ButtonsContainer>
        <RenderIf condition={!!onCancel}>
          <Button
            buttonType="stroke"
            width="100%"
            disabled={isLoading}
            onClick={onCancel}
          >
            {cancelText || t('common.no')}
          </Button>
        </RenderIf>
        <RenderIf condition={!!onConfirm}>
          <Button
            buttonType="common"
            width="100%"
            isLoading={isLoading}
            onClick={onConfirm}
          >
            {okText || t('buttons.ok')}
          </Button>
        </RenderIf>
      </ButtonsContainer>
    </ConfirmationModalContainer>
  )
}
